import React from 'react';
import {makeStyles} from '@material-ui/core';
import DocumentIcon from '@material-ui/icons/Description';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ExtensionIcon from '@material-ui/icons/Extension';
import CodeIcon from '@material-ui/icons/Code';
import {TMNA_COLOR_SCHEME, TMNATheme} from 'tmna-theme';

enum TMNATemplateTypes {
    InfraSkeleton = 'infrastructure skeleton',
    InfraModule = 'infrastructure module',
    TechDocs = 'documentation'
}

export const useStyles = makeStyles<TMNATheme>(theme => ({
    card: {
        borderRadius: '50%',
        height: '24px',
        width: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        color: theme.palette.tmnaColors?.primary.white,
        fontSize: '16px',
    }
}));

const getBackgroundColor = (type: TMNATemplateTypes | string) => {
    switch(type) {
        case TMNATemplateTypes.InfraSkeleton:
        case TMNATemplateTypes.InfraModule:
            return TMNA_COLOR_SCHEME.secondary.blue;
        case TMNATemplateTypes.TechDocs:
            return TMNA_COLOR_SCHEME.primary.red;
        default:
            return TMNA_COLOR_SCHEME.primary.gray;
    }
}

const getIcon = (type: TMNATemplateTypes | string) => {
    switch(type) {
        case TMNATemplateTypes.InfraSkeleton:
            return AccountTreeIcon;
        case TMNATemplateTypes.InfraModule:
            return ExtensionIcon;
        case TMNATemplateTypes.TechDocs:
            return DocumentIcon;
        default:
            return CodeIcon;
    }
}

export type Props = {
    type: string;
};

export const TemplateCardIcon = ({
    type,
}: Props) => {
    const classes = useStyles();
    const style = React.useMemo(() => ({
        backgroundColor: getBackgroundColor(type),
    }), [type]);

    const Icon = React.useMemo(() => (
        getIcon(type)
    ), [type]);

    return (
        <div className={classes.card} style={style}>
            <Icon className={classes.icon}/>
        </div>
    );
};
